import React from "react";
import { Box, Typography, Button } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import PetsIcon from "@mui/icons-material/Pets";

interface EmptyStateProps {
  onResetFilters?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onResetFilters }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        px: 3,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: "rgba(23, 139, 142, 0.1)",
          mb: 3,
        }}
      >
        <SearchOffIcon sx={{ fontSize: 40, color: "#178B8E" }} />
      </Box>

      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mb: 1, color: "#1A1A1A" }}
      >
        No sitters found
      </Typography>

      <Typography variant="body1" sx={{ color: "#5A5A5A", mb: 3, maxWidth: 300, mx: "auto" }}>
        We couldn't find any sitters matching your criteria. Try adjusting your
        filters or search in a different area.
      </Typography>

      <Button
        variant="outlined"
        onClick={onResetFilters}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderColor: "#178B8E",
          color: "#178B8E",
          px: 3,
          "&:hover": {
            borderColor: "#0F6164",
            backgroundColor: "rgba(23, 139, 142, 0.08)",
          },
        }}
      >
        Reset Filters
      </Button>

      <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 1 }}>
        <PetsIcon sx={{ color: "#178B8E", opacity: 0.3 }} />
        <PetsIcon sx={{ color: "#178B8E", opacity: 0.5 }} />
        <PetsIcon sx={{ color: "#178B8E", opacity: 0.3 }} />
      </Box>
    </Box>
  );
};

export default EmptyState;
